import { render, staticRenderFns } from "./Ongkir.vue?vue&type=template&id=027b1a38&scoped=true&"
import script from "./Ongkir.vue?vue&type=script&lang=js&"
export * from "./Ongkir.vue?vue&type=script&lang=js&"
import style0 from "./Ongkir.vue?vue&type=style&index=0&id=027b1a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b1a38",
  null
  
)

export default component.exports